.truncated-group {
    width: calc(100% - 32px);
}
